export class Constants {

  static readonly PREFILLED_INSURER_QUESTION = 'prefilled.insurer';
  static readonly PREFILLED_LEASECOMPANY_QUESTION = 'prefilledLeasecompany';
}
